import Bugsnag from "@bugsnag/js";
import { Component } from "react";
import ErrorFallback from "./ErrorFallback";

export default class ErrorBoundary extends Component {
	constructor(props) {
		super(props);
		this.state = { hasError: false };
	}

	static getDerivedStateFromError() {
		return { hasError: true };
	}

	componentDidCatch(error, errorInfo) {
		if (import.meta.env.VITE_ENV === "pro") {
			Bugsnag.notify(error, (event) => {
				event.addMetadata("react", errorInfo);
			});
		}
	}

	render() {
		if (this.state.hasError) {
			return <ErrorFallback />;
		}

		return this.props.children;
	}
}
